import nothing from '../../assets/img/owl-accessoirs/nothing.png'

import glasses from '../../assets/img/owl-accessoirs/glasses.png'
import glasses_shaded from '../../assets/img/owl-accessoirs/glasses_shaded.png'
import glasses_side from '../../assets/img/owl-accessoirs/glasses_side.png'
import glasses_back from '../../assets/img/owl-accessoirs/glasses_back.png'

import hornbrille from '../../assets/img/owl-accessoirs/hornbrille.png'
import hornbrille_side from '../../assets/img/owl-accessoirs/hornbrille_side.png'
import hornbrille_back from '../../assets/img/owl-accessoirs/hornbrille_back.png'

import heiligenschein from '../../assets/img/owl-accessoirs/heiligenschein.png'
import heiligenschein_side from '../../assets/img/owl-accessoirs/heiligenschein_side.png'
import heiligenschein_back from '../../assets/img/owl-accessoirs/heiligenschein_back.png'

import piratenklappe from '../../assets/img/owl-accessoirs/piratenklappe.png'
import piratenklappe_side from '../../assets/img/owl-accessoirs/piratenklappe_side.png'
import piratenklappe_back from '../../assets/img/owl-accessoirs/piratenklappe_back.png'

import beard from '../../assets/img/owl-accessoirs/beard.png'
import beard_side from '../../assets/img/owl-accessoirs/beard_side.png'


//import arch from '../../assets/img/owl-accessoirs/arch.png'
//import windows from '../../assets/img/owl-accessoirs/windows.png'
import kleeblatt from '../../assets/img/owl-accessoirs/kleeblatt.png'
import herzStern from '../../assets/img/owl-accessoirs/herz-stern.png'
import smiley from '../../assets/img/owl-accessoirs/smiley.png'
import iloveprog from '../../assets/img/owl-accessoirs/iloveprog.png'
import tie from '../../assets/img/owl-accessoirs/schlips.png'
import bowtie from '../../assets/img/owl-accessoirs/fliege.png'


const state = {
    accessoirs_body: [
        {
          src_front: nothing,
          name: 'Nothing',
        },
        /*{
          src_front: arch,
          name: 'Arch'
        },
        {
          src_front:windows,
          name:'Windows'
        },*/
        {
          src_front:tie,
          name:"Tie"
        },
        {
          src_front: bowtie,
          name: "Bow Tie"
        },
        {
          src_front:kleeblatt,
          name: 'Cloverleaf'
        },
        {
          src_front: herzStern,
          name: 'Heart&star'
        },
        {
          src_front: smiley,
          name: 'Smiley'
        },
        {
          src_front: iloveprog,
          name: 'I <3 Prog2'
        }
    ],
    accessoirs_head: [
        {
          src_front: nothing,
          name: 'Nothing'
        },
        {
          src_front:heiligenschein,
          src_side: heiligenschein_side,
          src_back: heiligenschein_back,
          name: 'Halo'
        },
        {
          src_front: glasses,
          src_side: glasses_side,
          src_back: glasses_back,
          name: 'Glasses'
        },
        {
          src_front: glasses_shaded,
          src_side: glasses_side,
          src_back: glasses_back,
          name: 'Glasses (shaded)'
        },
        {
          src_front: hornbrille,
          src_side: hornbrille_side,
          src_back: hornbrille_back,
          name: 'Horn glasses'
        },
        {
          src_front: piratenklappe,
          src_side: piratenklappe_side,
          src_back:piratenklappe_back,
          name: 'Eye patch'
        },
        {
          src_front:beard,
          src_side: beard_side,
          name: 'Beard'
        }
      ]
  };

function flip(src,target){
  var img = new Image();
  img.onload = function(){
   var c = document.createElement('canvas');
   c.width = this.width;
   c.height = this.height;
   var ctx = c.getContext('2d');
   ctx.scale(-1,1);
   ctx.drawImage(this,-this.width,0);
   this.onload = undefined;
   target.src = c.toDataURL();
  }
  img.src = src;
 }

var createImage = (acc => {
  acc.img_front = new Image();
  acc.img_front.src = acc.src_front;

  acc.img_left = new Image();
  acc.img_left.src = acc.src_side;

  acc.img_right = new Image();
  flip(acc.img_left.src, acc.img_right)

  acc.img_back = new Image();
  acc.img_back.src = acc.src_back;
})
state.accessoirs_body.forEach(createImage)
state.accessoirs_head.forEach(createImage)

  export default {
    namespaced: true,
    state,
  };
